/**
 * @fileoverview gRPC-Web generated client stub for manabie.bob
 * @enhanceable
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
var grpc = {};
grpc.web = require('grpc-web');

var enum_pb = require('./enum_pb.js');

var google_protobuf_struct_pb = require('google-protobuf/google/protobuf/struct_pb.js');

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');

var proto = {};
proto.manabie = {};
proto.manabie.bob = require('./subscription_pb.js');
/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */

proto.manabie.bob.SubscriptionServiceClient = function (hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';
  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */

  this.client_ = new grpc.web.GrpcWebClientBase(options);
  /**
   * @private @const {string} The hostname
   */

  this.hostname_ = hostname;
  /**
   * @private @const {?Object} The credentials to be used to connect
   *    to the server
   */

  this.credentials_ = credentials;
  /**
   * @private @const {?Object} Options for the client
   */

  this.options_ = options;
};
/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */


proto.manabie.bob.SubscriptionServicePromiseClient = function (hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';
  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */

  this.client_ = new grpc.web.GrpcWebClientBase(options);
  /**
   * @private @const {string} The hostname
   */

  this.hostname_ = hostname;
  /**
   * @private @const {?Object} The credentials to be used to connect
   *    to the server
   */

  this.credentials_ = credentials;
  /**
   * @private @const {?Object} Options for the client
   */

  this.options_ = options;
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manabie.bob.RetrievePlansRequest,
 *   !proto.manabie.bob.RetrievePlansResponse>}
 */


var methodDescriptor_SubscriptionService_RetrievePlans = new grpc.web.MethodDescriptor('/manabie.bob.SubscriptionService/RetrievePlans', grpc.web.MethodType.UNARY, proto.manabie.bob.RetrievePlansRequest, proto.manabie.bob.RetrievePlansResponse,
/** @param {!proto.manabie.bob.RetrievePlansRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.RetrievePlansResponse.deserializeBinary);
/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.manabie.bob.RetrievePlansRequest,
 *   !proto.manabie.bob.RetrievePlansResponse>}
 */

var methodInfo_SubscriptionService_RetrievePlans = new grpc.web.AbstractClientBase.MethodInfo(proto.manabie.bob.RetrievePlansResponse,
/** @param {!proto.manabie.bob.RetrievePlansRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.RetrievePlansResponse.deserializeBinary);
/**
 * @param {!proto.manabie.bob.RetrievePlansRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.manabie.bob.RetrievePlansResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.manabie.bob.RetrievePlansResponse>|undefined}
 *     The XHR Node Readable Stream
 */

proto.manabie.bob.SubscriptionServiceClient.prototype.retrievePlans = function (request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ + '/manabie.bob.SubscriptionService/RetrievePlans', request, metadata || {}, methodDescriptor_SubscriptionService_RetrievePlans, callback);
};
/**
 * @param {!proto.manabie.bob.RetrievePlansRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.manabie.bob.RetrievePlansResponse>}
 *     A native promise that resolves to the response
 */


proto.manabie.bob.SubscriptionServicePromiseClient.prototype.retrievePlans = function (request, metadata) {
  return this.client_.unaryCall(this.hostname_ + '/manabie.bob.SubscriptionService/RetrievePlans', request, metadata || {}, methodDescriptor_SubscriptionService_RetrievePlans);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manabie.bob.RetrievePackagesRequest,
 *   !proto.manabie.bob.RetrievePackagesResponse>}
 */


var methodDescriptor_SubscriptionService_RetrievePackages = new grpc.web.MethodDescriptor('/manabie.bob.SubscriptionService/RetrievePackages', grpc.web.MethodType.UNARY, proto.manabie.bob.RetrievePackagesRequest, proto.manabie.bob.RetrievePackagesResponse,
/** @param {!proto.manabie.bob.RetrievePackagesRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.RetrievePackagesResponse.deserializeBinary);
/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.manabie.bob.RetrievePackagesRequest,
 *   !proto.manabie.bob.RetrievePackagesResponse>}
 */

var methodInfo_SubscriptionService_RetrievePackages = new grpc.web.AbstractClientBase.MethodInfo(proto.manabie.bob.RetrievePackagesResponse,
/** @param {!proto.manabie.bob.RetrievePackagesRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.RetrievePackagesResponse.deserializeBinary);
/**
 * @param {!proto.manabie.bob.RetrievePackagesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.manabie.bob.RetrievePackagesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.manabie.bob.RetrievePackagesResponse>|undefined}
 *     The XHR Node Readable Stream
 */

proto.manabie.bob.SubscriptionServiceClient.prototype.retrievePackages = function (request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ + '/manabie.bob.SubscriptionService/RetrievePackages', request, metadata || {}, methodDescriptor_SubscriptionService_RetrievePackages, callback);
};
/**
 * @param {!proto.manabie.bob.RetrievePackagesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.manabie.bob.RetrievePackagesResponse>}
 *     A native promise that resolves to the response
 */


proto.manabie.bob.SubscriptionServicePromiseClient.prototype.retrievePackages = function (request, metadata) {
  return this.client_.unaryCall(this.hostname_ + '/manabie.bob.SubscriptionService/RetrievePackages', request, metadata || {}, methodDescriptor_SubscriptionService_RetrievePackages);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manabie.bob.RetrievePromotionCodePrefixesRequest,
 *   !proto.manabie.bob.RetrievePromotionCodePrefixesResponse>}
 */


var methodDescriptor_SubscriptionService_RetrievePromotionCodePrefixes = new grpc.web.MethodDescriptor('/manabie.bob.SubscriptionService/RetrievePromotionCodePrefixes', grpc.web.MethodType.UNARY, proto.manabie.bob.RetrievePromotionCodePrefixesRequest, proto.manabie.bob.RetrievePromotionCodePrefixesResponse,
/** @param {!proto.manabie.bob.RetrievePromotionCodePrefixesRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.RetrievePromotionCodePrefixesResponse.deserializeBinary);
/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.manabie.bob.RetrievePromotionCodePrefixesRequest,
 *   !proto.manabie.bob.RetrievePromotionCodePrefixesResponse>}
 */

var methodInfo_SubscriptionService_RetrievePromotionCodePrefixes = new grpc.web.AbstractClientBase.MethodInfo(proto.manabie.bob.RetrievePromotionCodePrefixesResponse,
/** @param {!proto.manabie.bob.RetrievePromotionCodePrefixesRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.RetrievePromotionCodePrefixesResponse.deserializeBinary);
/**
 * @param {!proto.manabie.bob.RetrievePromotionCodePrefixesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.manabie.bob.RetrievePromotionCodePrefixesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.manabie.bob.RetrievePromotionCodePrefixesResponse>|undefined}
 *     The XHR Node Readable Stream
 */

proto.manabie.bob.SubscriptionServiceClient.prototype.retrievePromotionCodePrefixes = function (request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ + '/manabie.bob.SubscriptionService/RetrievePromotionCodePrefixes', request, metadata || {}, methodDescriptor_SubscriptionService_RetrievePromotionCodePrefixes, callback);
};
/**
 * @param {!proto.manabie.bob.RetrievePromotionCodePrefixesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.manabie.bob.RetrievePromotionCodePrefixesResponse>}
 *     A native promise that resolves to the response
 */


proto.manabie.bob.SubscriptionServicePromiseClient.prototype.retrievePromotionCodePrefixes = function (request, metadata) {
  return this.client_.unaryCall(this.hostname_ + '/manabie.bob.SubscriptionService/RetrievePromotionCodePrefixes', request, metadata || {}, methodDescriptor_SubscriptionService_RetrievePromotionCodePrefixes);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manabie.bob.UsePromotionCodeRequest,
 *   !proto.manabie.bob.UsePromotionCodeResponse>}
 */


var methodDescriptor_SubscriptionService_UsePromotionCode = new grpc.web.MethodDescriptor('/manabie.bob.SubscriptionService/UsePromotionCode', grpc.web.MethodType.UNARY, proto.manabie.bob.UsePromotionCodeRequest, proto.manabie.bob.UsePromotionCodeResponse,
/** @param {!proto.manabie.bob.UsePromotionCodeRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.UsePromotionCodeResponse.deserializeBinary);
/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.manabie.bob.UsePromotionCodeRequest,
 *   !proto.manabie.bob.UsePromotionCodeResponse>}
 */

var methodInfo_SubscriptionService_UsePromotionCode = new grpc.web.AbstractClientBase.MethodInfo(proto.manabie.bob.UsePromotionCodeResponse,
/** @param {!proto.manabie.bob.UsePromotionCodeRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.UsePromotionCodeResponse.deserializeBinary);
/**
 * @param {!proto.manabie.bob.UsePromotionCodeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.manabie.bob.UsePromotionCodeResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.manabie.bob.UsePromotionCodeResponse>|undefined}
 *     The XHR Node Readable Stream
 */

proto.manabie.bob.SubscriptionServiceClient.prototype.usePromotionCode = function (request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ + '/manabie.bob.SubscriptionService/UsePromotionCode', request, metadata || {}, methodDescriptor_SubscriptionService_UsePromotionCode, callback);
};
/**
 * @param {!proto.manabie.bob.UsePromotionCodeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.manabie.bob.UsePromotionCodeResponse>}
 *     A native promise that resolves to the response
 */


proto.manabie.bob.SubscriptionServicePromiseClient.prototype.usePromotionCode = function (request, metadata) {
  return this.client_.unaryCall(this.hostname_ + '/manabie.bob.SubscriptionService/UsePromotionCode', request, metadata || {}, methodDescriptor_SubscriptionService_UsePromotionCode);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manabie.bob.CheckPromotionCodeRequest,
 *   !proto.manabie.bob.CheckPromotionCodeResponse>}
 */


var methodDescriptor_SubscriptionService_CheckPromotionCode = new grpc.web.MethodDescriptor('/manabie.bob.SubscriptionService/CheckPromotionCode', grpc.web.MethodType.UNARY, proto.manabie.bob.CheckPromotionCodeRequest, proto.manabie.bob.CheckPromotionCodeResponse,
/** @param {!proto.manabie.bob.CheckPromotionCodeRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.CheckPromotionCodeResponse.deserializeBinary);
/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.manabie.bob.CheckPromotionCodeRequest,
 *   !proto.manabie.bob.CheckPromotionCodeResponse>}
 */

var methodInfo_SubscriptionService_CheckPromotionCode = new grpc.web.AbstractClientBase.MethodInfo(proto.manabie.bob.CheckPromotionCodeResponse,
/** @param {!proto.manabie.bob.CheckPromotionCodeRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.CheckPromotionCodeResponse.deserializeBinary);
/**
 * @param {!proto.manabie.bob.CheckPromotionCodeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.manabie.bob.CheckPromotionCodeResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.manabie.bob.CheckPromotionCodeResponse>|undefined}
 *     The XHR Node Readable Stream
 */

proto.manabie.bob.SubscriptionServiceClient.prototype.checkPromotionCode = function (request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ + '/manabie.bob.SubscriptionService/CheckPromotionCode', request, metadata || {}, methodDescriptor_SubscriptionService_CheckPromotionCode, callback);
};
/**
 * @param {!proto.manabie.bob.CheckPromotionCodeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.manabie.bob.CheckPromotionCodeResponse>}
 *     A native promise that resolves to the response
 */


proto.manabie.bob.SubscriptionServicePromiseClient.prototype.checkPromotionCode = function (request, metadata) {
  return this.client_.unaryCall(this.hostname_ + '/manabie.bob.SubscriptionService/CheckPromotionCode', request, metadata || {}, methodDescriptor_SubscriptionService_CheckPromotionCode);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manabie.bob.CreatePromotionRequest,
 *   !proto.manabie.bob.CreatePromotionResponse>}
 */


var methodDescriptor_SubscriptionService_CreatePromotion = new grpc.web.MethodDescriptor('/manabie.bob.SubscriptionService/CreatePromotion', grpc.web.MethodType.UNARY, proto.manabie.bob.CreatePromotionRequest, proto.manabie.bob.CreatePromotionResponse,
/** @param {!proto.manabie.bob.CreatePromotionRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.CreatePromotionResponse.deserializeBinary);
/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.manabie.bob.CreatePromotionRequest,
 *   !proto.manabie.bob.CreatePromotionResponse>}
 */

var methodInfo_SubscriptionService_CreatePromotion = new grpc.web.AbstractClientBase.MethodInfo(proto.manabie.bob.CreatePromotionResponse,
/** @param {!proto.manabie.bob.CreatePromotionRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.CreatePromotionResponse.deserializeBinary);
/**
 * @param {!proto.manabie.bob.CreatePromotionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.manabie.bob.CreatePromotionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.manabie.bob.CreatePromotionResponse>|undefined}
 *     The XHR Node Readable Stream
 */

proto.manabie.bob.SubscriptionServiceClient.prototype.createPromotion = function (request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ + '/manabie.bob.SubscriptionService/CreatePromotion', request, metadata || {}, methodDescriptor_SubscriptionService_CreatePromotion, callback);
};
/**
 * @param {!proto.manabie.bob.CreatePromotionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.manabie.bob.CreatePromotionResponse>}
 *     A native promise that resolves to the response
 */


proto.manabie.bob.SubscriptionServicePromiseClient.prototype.createPromotion = function (request, metadata) {
  return this.client_.unaryCall(this.hostname_ + '/manabie.bob.SubscriptionService/CreatePromotion', request, metadata || {}, methodDescriptor_SubscriptionService_CreatePromotion);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manabie.bob.UpdatePromotionRequest,
 *   !proto.manabie.bob.UpdatePromotionResponse>}
 */


var methodDescriptor_SubscriptionService_UpdatePromotion = new grpc.web.MethodDescriptor('/manabie.bob.SubscriptionService/UpdatePromotion', grpc.web.MethodType.UNARY, proto.manabie.bob.UpdatePromotionRequest, proto.manabie.bob.UpdatePromotionResponse,
/** @param {!proto.manabie.bob.UpdatePromotionRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.UpdatePromotionResponse.deserializeBinary);
/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.manabie.bob.UpdatePromotionRequest,
 *   !proto.manabie.bob.UpdatePromotionResponse>}
 */

var methodInfo_SubscriptionService_UpdatePromotion = new grpc.web.AbstractClientBase.MethodInfo(proto.manabie.bob.UpdatePromotionResponse,
/** @param {!proto.manabie.bob.UpdatePromotionRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.UpdatePromotionResponse.deserializeBinary);
/**
 * @param {!proto.manabie.bob.UpdatePromotionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.manabie.bob.UpdatePromotionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.manabie.bob.UpdatePromotionResponse>|undefined}
 *     The XHR Node Readable Stream
 */

proto.manabie.bob.SubscriptionServiceClient.prototype.updatePromotion = function (request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ + '/manabie.bob.SubscriptionService/UpdatePromotion', request, metadata || {}, methodDescriptor_SubscriptionService_UpdatePromotion, callback);
};
/**
 * @param {!proto.manabie.bob.UpdatePromotionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.manabie.bob.UpdatePromotionResponse>}
 *     A native promise that resolves to the response
 */


proto.manabie.bob.SubscriptionServicePromiseClient.prototype.updatePromotion = function (request, metadata) {
  return this.client_.unaryCall(this.hostname_ + '/manabie.bob.SubscriptionService/UpdatePromotion', request, metadata || {}, methodDescriptor_SubscriptionService_UpdatePromotion);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manabie.bob.CreateOnlineOrderRequest,
 *   !proto.manabie.bob.CreateOnlineOrderResponse>}
 */


var methodDescriptor_SubscriptionService_CreateOnlineOrder = new grpc.web.MethodDescriptor('/manabie.bob.SubscriptionService/CreateOnlineOrder', grpc.web.MethodType.UNARY, proto.manabie.bob.CreateOnlineOrderRequest, proto.manabie.bob.CreateOnlineOrderResponse,
/** @param {!proto.manabie.bob.CreateOnlineOrderRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.CreateOnlineOrderResponse.deserializeBinary);
/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.manabie.bob.CreateOnlineOrderRequest,
 *   !proto.manabie.bob.CreateOnlineOrderResponse>}
 */

var methodInfo_SubscriptionService_CreateOnlineOrder = new grpc.web.AbstractClientBase.MethodInfo(proto.manabie.bob.CreateOnlineOrderResponse,
/** @param {!proto.manabie.bob.CreateOnlineOrderRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.CreateOnlineOrderResponse.deserializeBinary);
/**
 * @param {!proto.manabie.bob.CreateOnlineOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.manabie.bob.CreateOnlineOrderResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.manabie.bob.CreateOnlineOrderResponse>|undefined}
 *     The XHR Node Readable Stream
 */

proto.manabie.bob.SubscriptionServiceClient.prototype.createOnlineOrder = function (request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ + '/manabie.bob.SubscriptionService/CreateOnlineOrder', request, metadata || {}, methodDescriptor_SubscriptionService_CreateOnlineOrder, callback);
};
/**
 * @param {!proto.manabie.bob.CreateOnlineOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.manabie.bob.CreateOnlineOrderResponse>}
 *     A native promise that resolves to the response
 */


proto.manabie.bob.SubscriptionServicePromiseClient.prototype.createOnlineOrder = function (request, metadata) {
  return this.client_.unaryCall(this.hostname_ + '/manabie.bob.SubscriptionService/CreateOnlineOrder', request, metadata || {}, methodDescriptor_SubscriptionService_CreateOnlineOrder);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manabie.bob.CreateGHNOrderRequest,
 *   !proto.manabie.bob.CreateGHNOrderResponse>}
 */


var methodDescriptor_SubscriptionService_CreateGHNOrder = new grpc.web.MethodDescriptor('/manabie.bob.SubscriptionService/CreateGHNOrder', grpc.web.MethodType.UNARY, proto.manabie.bob.CreateGHNOrderRequest, proto.manabie.bob.CreateGHNOrderResponse,
/** @param {!proto.manabie.bob.CreateGHNOrderRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.CreateGHNOrderResponse.deserializeBinary);
/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.manabie.bob.CreateGHNOrderRequest,
 *   !proto.manabie.bob.CreateGHNOrderResponse>}
 */

var methodInfo_SubscriptionService_CreateGHNOrder = new grpc.web.AbstractClientBase.MethodInfo(proto.manabie.bob.CreateGHNOrderResponse,
/** @param {!proto.manabie.bob.CreateGHNOrderRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.CreateGHNOrderResponse.deserializeBinary);
/**
 * @param {!proto.manabie.bob.CreateGHNOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.manabie.bob.CreateGHNOrderResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.manabie.bob.CreateGHNOrderResponse>|undefined}
 *     The XHR Node Readable Stream
 */

proto.manabie.bob.SubscriptionServiceClient.prototype.createGHNOrder = function (request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ + '/manabie.bob.SubscriptionService/CreateGHNOrder', request, metadata || {}, methodDescriptor_SubscriptionService_CreateGHNOrder, callback);
};
/**
 * @param {!proto.manabie.bob.CreateGHNOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.manabie.bob.CreateGHNOrderResponse>}
 *     A native promise that resolves to the response
 */


proto.manabie.bob.SubscriptionServicePromiseClient.prototype.createGHNOrder = function (request, metadata) {
  return this.client_.unaryCall(this.hostname_ + '/manabie.bob.SubscriptionService/CreateGHNOrder', request, metadata || {}, methodDescriptor_SubscriptionService_CreateGHNOrder);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manabie.bob.UpdatePaymentMethodRequest,
 *   !proto.manabie.bob.UpdatePaymentMethodResponse>}
 */


var methodDescriptor_SubscriptionService_UpdatePaymentMethod = new grpc.web.MethodDescriptor('/manabie.bob.SubscriptionService/UpdatePaymentMethod', grpc.web.MethodType.UNARY, proto.manabie.bob.UpdatePaymentMethodRequest, proto.manabie.bob.UpdatePaymentMethodResponse,
/** @param {!proto.manabie.bob.UpdatePaymentMethodRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.UpdatePaymentMethodResponse.deserializeBinary);
/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.manabie.bob.UpdatePaymentMethodRequest,
 *   !proto.manabie.bob.UpdatePaymentMethodResponse>}
 */

var methodInfo_SubscriptionService_UpdatePaymentMethod = new grpc.web.AbstractClientBase.MethodInfo(proto.manabie.bob.UpdatePaymentMethodResponse,
/** @param {!proto.manabie.bob.UpdatePaymentMethodRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.UpdatePaymentMethodResponse.deserializeBinary);
/**
 * @param {!proto.manabie.bob.UpdatePaymentMethodRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.manabie.bob.UpdatePaymentMethodResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.manabie.bob.UpdatePaymentMethodResponse>|undefined}
 *     The XHR Node Readable Stream
 */

proto.manabie.bob.SubscriptionServiceClient.prototype.updatePaymentMethod = function (request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ + '/manabie.bob.SubscriptionService/UpdatePaymentMethod', request, metadata || {}, methodDescriptor_SubscriptionService_UpdatePaymentMethod, callback);
};
/**
 * @param {!proto.manabie.bob.UpdatePaymentMethodRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.manabie.bob.UpdatePaymentMethodResponse>}
 *     A native promise that resolves to the response
 */


proto.manabie.bob.SubscriptionServicePromiseClient.prototype.updatePaymentMethod = function (request, metadata) {
  return this.client_.unaryCall(this.hostname_ + '/manabie.bob.SubscriptionService/UpdatePaymentMethod', request, metadata || {}, methodDescriptor_SubscriptionService_UpdatePaymentMethod);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manabie.bob.MarkOrderProcessingRequest,
 *   !proto.manabie.bob.MarkOrderProcessingResponse>}
 */


var methodDescriptor_SubscriptionService_MarkOrderProcessing = new grpc.web.MethodDescriptor('/manabie.bob.SubscriptionService/MarkOrderProcessing', grpc.web.MethodType.UNARY, proto.manabie.bob.MarkOrderProcessingRequest, proto.manabie.bob.MarkOrderProcessingResponse,
/** @param {!proto.manabie.bob.MarkOrderProcessingRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.MarkOrderProcessingResponse.deserializeBinary);
/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.manabie.bob.MarkOrderProcessingRequest,
 *   !proto.manabie.bob.MarkOrderProcessingResponse>}
 */

var methodInfo_SubscriptionService_MarkOrderProcessing = new grpc.web.AbstractClientBase.MethodInfo(proto.manabie.bob.MarkOrderProcessingResponse,
/** @param {!proto.manabie.bob.MarkOrderProcessingRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.MarkOrderProcessingResponse.deserializeBinary);
/**
 * @param {!proto.manabie.bob.MarkOrderProcessingRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.manabie.bob.MarkOrderProcessingResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.manabie.bob.MarkOrderProcessingResponse>|undefined}
 *     The XHR Node Readable Stream
 */

proto.manabie.bob.SubscriptionServiceClient.prototype.markOrderProcessing = function (request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ + '/manabie.bob.SubscriptionService/MarkOrderProcessing', request, metadata || {}, methodDescriptor_SubscriptionService_MarkOrderProcessing, callback);
};
/**
 * @param {!proto.manabie.bob.MarkOrderProcessingRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.manabie.bob.MarkOrderProcessingResponse>}
 *     A native promise that resolves to the response
 */


proto.manabie.bob.SubscriptionServicePromiseClient.prototype.markOrderProcessing = function (request, metadata) {
  return this.client_.unaryCall(this.hostname_ + '/manabie.bob.SubscriptionService/MarkOrderProcessing', request, metadata || {}, methodDescriptor_SubscriptionService_MarkOrderProcessing);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manabie.bob.ListOrdersRequest,
 *   !proto.manabie.bob.ListOrdersResponse>}
 */


var methodDescriptor_SubscriptionService_ListOrders = new grpc.web.MethodDescriptor('/manabie.bob.SubscriptionService/ListOrders', grpc.web.MethodType.UNARY, proto.manabie.bob.ListOrdersRequest, proto.manabie.bob.ListOrdersResponse,
/** @param {!proto.manabie.bob.ListOrdersRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.ListOrdersResponse.deserializeBinary);
/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.manabie.bob.ListOrdersRequest,
 *   !proto.manabie.bob.ListOrdersResponse>}
 */

var methodInfo_SubscriptionService_ListOrders = new grpc.web.AbstractClientBase.MethodInfo(proto.manabie.bob.ListOrdersResponse,
/** @param {!proto.manabie.bob.ListOrdersRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.ListOrdersResponse.deserializeBinary);
/**
 * @param {!proto.manabie.bob.ListOrdersRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.manabie.bob.ListOrdersResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.manabie.bob.ListOrdersResponse>|undefined}
 *     The XHR Node Readable Stream
 */

proto.manabie.bob.SubscriptionServiceClient.prototype.listOrders = function (request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ + '/manabie.bob.SubscriptionService/ListOrders', request, metadata || {}, methodDescriptor_SubscriptionService_ListOrders, callback);
};
/**
 * @param {!proto.manabie.bob.ListOrdersRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.manabie.bob.ListOrdersResponse>}
 *     A native promise that resolves to the response
 */


proto.manabie.bob.SubscriptionServicePromiseClient.prototype.listOrders = function (request, metadata) {
  return this.client_.unaryCall(this.hostname_ + '/manabie.bob.SubscriptionService/ListOrders', request, metadata || {}, methodDescriptor_SubscriptionService_ListOrders);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manabie.bob.UpdateAsiaPayOrderRequest,
 *   !proto.manabie.bob.UpdateAsiaPayOrderResponse>}
 */


var methodDescriptor_SubscriptionService_UpdateAsiaPayOrder = new grpc.web.MethodDescriptor('/manabie.bob.SubscriptionService/UpdateAsiaPayOrder', grpc.web.MethodType.UNARY, proto.manabie.bob.UpdateAsiaPayOrderRequest, proto.manabie.bob.UpdateAsiaPayOrderResponse,
/** @param {!proto.manabie.bob.UpdateAsiaPayOrderRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.UpdateAsiaPayOrderResponse.deserializeBinary);
/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.manabie.bob.UpdateAsiaPayOrderRequest,
 *   !proto.manabie.bob.UpdateAsiaPayOrderResponse>}
 */

var methodInfo_SubscriptionService_UpdateAsiaPayOrder = new grpc.web.AbstractClientBase.MethodInfo(proto.manabie.bob.UpdateAsiaPayOrderResponse,
/** @param {!proto.manabie.bob.UpdateAsiaPayOrderRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.UpdateAsiaPayOrderResponse.deserializeBinary);
/**
 * @param {!proto.manabie.bob.UpdateAsiaPayOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.manabie.bob.UpdateAsiaPayOrderResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.manabie.bob.UpdateAsiaPayOrderResponse>|undefined}
 *     The XHR Node Readable Stream
 */

proto.manabie.bob.SubscriptionServiceClient.prototype.updateAsiaPayOrder = function (request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ + '/manabie.bob.SubscriptionService/UpdateAsiaPayOrder', request, metadata || {}, methodDescriptor_SubscriptionService_UpdateAsiaPayOrder, callback);
};
/**
 * @param {!proto.manabie.bob.UpdateAsiaPayOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.manabie.bob.UpdateAsiaPayOrderResponse>}
 *     A native promise that resolves to the response
 */


proto.manabie.bob.SubscriptionServicePromiseClient.prototype.updateAsiaPayOrder = function (request, metadata) {
  return this.client_.unaryCall(this.hostname_ + '/manabie.bob.SubscriptionService/UpdateAsiaPayOrder', request, metadata || {}, methodDescriptor_SubscriptionService_UpdateAsiaPayOrder);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manabie.bob.UpdateGHNOrderRequest,
 *   !proto.manabie.bob.UpdateGHNOrderResponse>}
 */


var methodDescriptor_SubscriptionService_UpdateGHNOrder = new grpc.web.MethodDescriptor('/manabie.bob.SubscriptionService/UpdateGHNOrder', grpc.web.MethodType.UNARY, proto.manabie.bob.UpdateGHNOrderRequest, proto.manabie.bob.UpdateGHNOrderResponse,
/** @param {!proto.manabie.bob.UpdateGHNOrderRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.UpdateGHNOrderResponse.deserializeBinary);
/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.manabie.bob.UpdateGHNOrderRequest,
 *   !proto.manabie.bob.UpdateGHNOrderResponse>}
 */

var methodInfo_SubscriptionService_UpdateGHNOrder = new grpc.web.AbstractClientBase.MethodInfo(proto.manabie.bob.UpdateGHNOrderResponse,
/** @param {!proto.manabie.bob.UpdateGHNOrderRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.UpdateGHNOrderResponse.deserializeBinary);
/**
 * @param {!proto.manabie.bob.UpdateGHNOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.manabie.bob.UpdateGHNOrderResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.manabie.bob.UpdateGHNOrderResponse>|undefined}
 *     The XHR Node Readable Stream
 */

proto.manabie.bob.SubscriptionServiceClient.prototype.updateGHNOrder = function (request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ + '/manabie.bob.SubscriptionService/UpdateGHNOrder', request, metadata || {}, methodDescriptor_SubscriptionService_UpdateGHNOrder, callback);
};
/**
 * @param {!proto.manabie.bob.UpdateGHNOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.manabie.bob.UpdateGHNOrderResponse>}
 *     A native promise that resolves to the response
 */


proto.manabie.bob.SubscriptionServicePromiseClient.prototype.updateGHNOrder = function (request, metadata) {
  return this.client_.unaryCall(this.hostname_ + '/manabie.bob.SubscriptionService/UpdateGHNOrder', request, metadata || {}, methodDescriptor_SubscriptionService_UpdateGHNOrder);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manabie.bob.CreateManualOrderRequest,
 *   !proto.manabie.bob.CreateManualOrderResponse>}
 */


var methodDescriptor_SubscriptionService_CreateManualOrder = new grpc.web.MethodDescriptor('/manabie.bob.SubscriptionService/CreateManualOrder', grpc.web.MethodType.UNARY, proto.manabie.bob.CreateManualOrderRequest, proto.manabie.bob.CreateManualOrderResponse,
/** @param {!proto.manabie.bob.CreateManualOrderRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.CreateManualOrderResponse.deserializeBinary);
/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.manabie.bob.CreateManualOrderRequest,
 *   !proto.manabie.bob.CreateManualOrderResponse>}
 */

var methodInfo_SubscriptionService_CreateManualOrder = new grpc.web.AbstractClientBase.MethodInfo(proto.manabie.bob.CreateManualOrderResponse,
/** @param {!proto.manabie.bob.CreateManualOrderRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.CreateManualOrderResponse.deserializeBinary);
/**
 * @param {!proto.manabie.bob.CreateManualOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.manabie.bob.CreateManualOrderResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.manabie.bob.CreateManualOrderResponse>|undefined}
 *     The XHR Node Readable Stream
 */

proto.manabie.bob.SubscriptionServiceClient.prototype.createManualOrder = function (request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ + '/manabie.bob.SubscriptionService/CreateManualOrder', request, metadata || {}, methodDescriptor_SubscriptionService_CreateManualOrder, callback);
};
/**
 * @param {!proto.manabie.bob.CreateManualOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.manabie.bob.CreateManualOrderResponse>}
 *     A native promise that resolves to the response
 */


proto.manabie.bob.SubscriptionServicePromiseClient.prototype.createManualOrder = function (request, metadata) {
  return this.client_.unaryCall(this.hostname_ + '/manabie.bob.SubscriptionService/CreateManualOrder', request, metadata || {}, methodDescriptor_SubscriptionService_CreateManualOrder);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manabie.bob.DisableOrderRequest,
 *   !proto.manabie.bob.DisableOrderResponse>}
 */


var methodDescriptor_SubscriptionService_DisableOrder = new grpc.web.MethodDescriptor('/manabie.bob.SubscriptionService/DisableOrder', grpc.web.MethodType.UNARY, proto.manabie.bob.DisableOrderRequest, proto.manabie.bob.DisableOrderResponse,
/** @param {!proto.manabie.bob.DisableOrderRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.DisableOrderResponse.deserializeBinary);
/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.manabie.bob.DisableOrderRequest,
 *   !proto.manabie.bob.DisableOrderResponse>}
 */

var methodInfo_SubscriptionService_DisableOrder = new grpc.web.AbstractClientBase.MethodInfo(proto.manabie.bob.DisableOrderResponse,
/** @param {!proto.manabie.bob.DisableOrderRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.DisableOrderResponse.deserializeBinary);
/**
 * @param {!proto.manabie.bob.DisableOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.manabie.bob.DisableOrderResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.manabie.bob.DisableOrderResponse>|undefined}
 *     The XHR Node Readable Stream
 */

proto.manabie.bob.SubscriptionServiceClient.prototype.disableOrder = function (request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ + '/manabie.bob.SubscriptionService/DisableOrder', request, metadata || {}, methodDescriptor_SubscriptionService_DisableOrder, callback);
};
/**
 * @param {!proto.manabie.bob.DisableOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.manabie.bob.DisableOrderResponse>}
 *     A native promise that resolves to the response
 */


proto.manabie.bob.SubscriptionServicePromiseClient.prototype.disableOrder = function (request, metadata) {
  return this.client_.unaryCall(this.hostname_ + '/manabie.bob.SubscriptionService/DisableOrder', request, metadata || {}, methodDescriptor_SubscriptionService_DisableOrder);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manabie.bob.RetrieveCurrentSubscriptionRequest,
 *   !proto.manabie.bob.RetrieveCurrentSubscriptionResponse>}
 */


var methodDescriptor_SubscriptionService_RetrieveCurrentSubscription = new grpc.web.MethodDescriptor('/manabie.bob.SubscriptionService/RetrieveCurrentSubscription', grpc.web.MethodType.UNARY, proto.manabie.bob.RetrieveCurrentSubscriptionRequest, proto.manabie.bob.RetrieveCurrentSubscriptionResponse,
/** @param {!proto.manabie.bob.RetrieveCurrentSubscriptionRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.RetrieveCurrentSubscriptionResponse.deserializeBinary);
/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.manabie.bob.RetrieveCurrentSubscriptionRequest,
 *   !proto.manabie.bob.RetrieveCurrentSubscriptionResponse>}
 */

var methodInfo_SubscriptionService_RetrieveCurrentSubscription = new grpc.web.AbstractClientBase.MethodInfo(proto.manabie.bob.RetrieveCurrentSubscriptionResponse,
/** @param {!proto.manabie.bob.RetrieveCurrentSubscriptionRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.RetrieveCurrentSubscriptionResponse.deserializeBinary);
/**
 * @param {!proto.manabie.bob.RetrieveCurrentSubscriptionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.manabie.bob.RetrieveCurrentSubscriptionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.manabie.bob.RetrieveCurrentSubscriptionResponse>|undefined}
 *     The XHR Node Readable Stream
 */

proto.manabie.bob.SubscriptionServiceClient.prototype.retrieveCurrentSubscription = function (request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ + '/manabie.bob.SubscriptionService/RetrieveCurrentSubscription', request, metadata || {}, methodDescriptor_SubscriptionService_RetrieveCurrentSubscription, callback);
};
/**
 * @param {!proto.manabie.bob.RetrieveCurrentSubscriptionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.manabie.bob.RetrieveCurrentSubscriptionResponse>}
 *     A native promise that resolves to the response
 */


proto.manabie.bob.SubscriptionServicePromiseClient.prototype.retrieveCurrentSubscription = function (request, metadata) {
  return this.client_.unaryCall(this.hostname_ + '/manabie.bob.SubscriptionService/RetrieveCurrentSubscription', request, metadata || {}, methodDescriptor_SubscriptionService_RetrieveCurrentSubscription);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manabie.bob.VerifyIosReceiptRequest,
 *   !proto.manabie.bob.VerifyIosReceiptResponse>}
 */


var methodDescriptor_SubscriptionService_VerifyIosReceipt = new grpc.web.MethodDescriptor('/manabie.bob.SubscriptionService/VerifyIosReceipt', grpc.web.MethodType.UNARY, proto.manabie.bob.VerifyIosReceiptRequest, proto.manabie.bob.VerifyIosReceiptResponse,
/** @param {!proto.manabie.bob.VerifyIosReceiptRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.VerifyIosReceiptResponse.deserializeBinary);
/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.manabie.bob.VerifyIosReceiptRequest,
 *   !proto.manabie.bob.VerifyIosReceiptResponse>}
 */

var methodInfo_SubscriptionService_VerifyIosReceipt = new grpc.web.AbstractClientBase.MethodInfo(proto.manabie.bob.VerifyIosReceiptResponse,
/** @param {!proto.manabie.bob.VerifyIosReceiptRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.VerifyIosReceiptResponse.deserializeBinary);
/**
 * @param {!proto.manabie.bob.VerifyIosReceiptRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.manabie.bob.VerifyIosReceiptResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.manabie.bob.VerifyIosReceiptResponse>|undefined}
 *     The XHR Node Readable Stream
 */

proto.manabie.bob.SubscriptionServiceClient.prototype.verifyIosReceipt = function (request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ + '/manabie.bob.SubscriptionService/VerifyIosReceipt', request, metadata || {}, methodDescriptor_SubscriptionService_VerifyIosReceipt, callback);
};
/**
 * @param {!proto.manabie.bob.VerifyIosReceiptRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.manabie.bob.VerifyIosReceiptResponse>}
 *     A native promise that resolves to the response
 */


proto.manabie.bob.SubscriptionServicePromiseClient.prototype.verifyIosReceipt = function (request, metadata) {
  return this.client_.unaryCall(this.hostname_ + '/manabie.bob.SubscriptionService/VerifyIosReceipt', request, metadata || {}, methodDescriptor_SubscriptionService_VerifyIosReceipt);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manabie.bob.RetrieveCarriedOverPromotionCodeRequest,
 *   !proto.manabie.bob.RetrieveCarriedOverPromotionCodeResponse>}
 */


var methodDescriptor_SubscriptionService_RetrieveCarriedOverPromotionCode = new grpc.web.MethodDescriptor('/manabie.bob.SubscriptionService/RetrieveCarriedOverPromotionCode', grpc.web.MethodType.UNARY, proto.manabie.bob.RetrieveCarriedOverPromotionCodeRequest, proto.manabie.bob.RetrieveCarriedOverPromotionCodeResponse,
/** @param {!proto.manabie.bob.RetrieveCarriedOverPromotionCodeRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.RetrieveCarriedOverPromotionCodeResponse.deserializeBinary);
/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.manabie.bob.RetrieveCarriedOverPromotionCodeRequest,
 *   !proto.manabie.bob.RetrieveCarriedOverPromotionCodeResponse>}
 */

var methodInfo_SubscriptionService_RetrieveCarriedOverPromotionCode = new grpc.web.AbstractClientBase.MethodInfo(proto.manabie.bob.RetrieveCarriedOverPromotionCodeResponse,
/** @param {!proto.manabie.bob.RetrieveCarriedOverPromotionCodeRequest} request */
function (request) {
  return request.serializeBinary();
}, proto.manabie.bob.RetrieveCarriedOverPromotionCodeResponse.deserializeBinary);
/**
 * @param {!proto.manabie.bob.RetrieveCarriedOverPromotionCodeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.manabie.bob.RetrieveCarriedOverPromotionCodeResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.manabie.bob.RetrieveCarriedOverPromotionCodeResponse>|undefined}
 *     The XHR Node Readable Stream
 */

proto.manabie.bob.SubscriptionServiceClient.prototype.retrieveCarriedOverPromotionCode = function (request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ + '/manabie.bob.SubscriptionService/RetrieveCarriedOverPromotionCode', request, metadata || {}, methodDescriptor_SubscriptionService_RetrieveCarriedOverPromotionCode, callback);
};
/**
 * @param {!proto.manabie.bob.RetrieveCarriedOverPromotionCodeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.manabie.bob.RetrieveCarriedOverPromotionCodeResponse>}
 *     A native promise that resolves to the response
 */


proto.manabie.bob.SubscriptionServicePromiseClient.prototype.retrieveCarriedOverPromotionCode = function (request, metadata) {
  return this.client_.unaryCall(this.hostname_ + '/manabie.bob.SubscriptionService/RetrieveCarriedOverPromotionCode', request, metadata || {}, methodDescriptor_SubscriptionService_RetrieveCarriedOverPromotionCode);
};

module.exports = proto.manabie.bob;